// extracted by mini-css-extract-plugin
export default {"GeneralModalMaker":"GeneralModalMaker_GeneralModalMaker__0Qkkw","buttonLabel":"GeneralModalMaker_buttonLabel__tO69i"};